// LockedDirectSelect mode
// Prevents focus been lost for currently selected item
// Only allows vertexs to be edited to prevent accidental movement
import MapboxDraw from '@mapbox/mapbox-gl-draw';
import ExtendedDirectSelect from './ExtendedDirectSelect';
import _ from 'lodash';

const LockedDirectSelect = _.extend({}, ExtendedDirectSelect);

// ExtendedDirectSelect.startDragging = function(state, e) {
//     MapboxDraw.modes.direct_select.startDragging.call(this, state, e);
//     CommonSelect.startOnActiveFeature.call(this, state, e);
// };

LockedDirectSelect.clickNoTarget = function () {
    // this.changeMode(Constants.modes.SIMPLE_SELECT);
};

LockedDirectSelect.clickInactive = function () {
    // this.changeMode(Constants.modes.SIMPLE_SELECT);
};

// LockedDirectSelect.onTrash = function(state) {
//     if (document.activeElement.className === 'mapboxgl-canvas') {
//         MapboxDraw.modes.direct_select.onTrash.call(this, state);
//     }
// };

LockedDirectSelect.onTrash = function (state) {
    // console.log(state);
    MapboxDraw.modes.direct_select.onTrash.call(this, state);

    // state.selectedCoordPaths
    //   .sort((a, b) => b.localeCompare(a, 'en', { numeric: true }))
    //   .forEach(id => state.feature.removeCoordinate(id));
    // this.fireUpdate();
    // state.selectedCoordPaths = [];
    // this.clearSelectedCoordinates();
    // this.fireActionable(state);
    // if (state.feature.isValid() === false) {
    //   this.deleteFeature([state.featureId]);
    //   this.changeMode(Constants.modes.SIMPLE_SELECT, {});
    // }
};

LockedDirectSelect.onFeature = function (state, e) {
    // Prevents the feature from been dragged by doing nothing
    // if (state.selectedCoordPaths.length === 0) this.startDragging(state, e);
    // else this.stopDragging(state);
};

export default LockedDirectSelect;